import * as tslib_1 from "tslib";
import * as React from 'react';
import JiraSwitcher from './jira-switcher';
import ConfluenceSwitcher from './confluence-switcher';
import GenericSwitcher from './generic-switcher';
import ErrorBoundary from './error-boundary';
import { Product } from '../types';
import IntlProvider from './intl-provider';
import messages from '../utils/messages';
import { analyticsAttributes, NavigationAnalyticsContext, SWITCHER_COMPONENT, SWITCHER_SOURCE } from '../utils/analytics';
import packageContext from '../utils/package-context';
import mapPropsToFeatures from '../utils/map-props-to-features';

var getAnalyticsContext = function getAnalyticsContext(attributes) {
  return tslib_1.__assign({
    source: SWITCHER_SOURCE,
    componentName: SWITCHER_COMPONENT
  }, packageContext, analyticsAttributes(attributes));
};

var AtlassianSwitcher = function AtlassianSwitcher(props) {
  var product = props.product;
  var Switcher;

  switch (product) {
    case Product.JIRA:
      Switcher = JiraSwitcher;
      break;

    case Product.CONFLUENCE:
      Switcher = ConfluenceSwitcher;
      break;

    default:
      Switcher = GenericSwitcher;
  }

  var features = mapPropsToFeatures(props);
  return React.createElement(IntlProvider, null, React.createElement(NavigationAnalyticsContext, {
    data: getAnalyticsContext({
      featureFlags: features
    })
  }, React.createElement(ErrorBoundary, {
    messages: messages
  }, React.createElement(Switcher, tslib_1.__assign({}, props, {
    messages: messages,
    features: features
  })))));
};

export default AtlassianSwitcher;